module.exports = __webpack_public_path__ + "img/72.679edfb0.png";